import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import './i18n/config'
import { registerServiceWorker } from './utils/offline'
import { generateLocationSequence } from './utils/gps-simulator'
import { getDeviceSensorsManager } from './utils/device-sensors'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// Register Service Worker on app load
registerServiceWorker()

// Expose API to console for testing
if (process.env.NODE_ENV === 'development') {
  window.gpsTest = {
    generateSequence: generateLocationSequence,
    // Inject a fake fix, e.g. gpsTest.emit(59.3293, 18.0686, 8)
    emit: (lat, lng, accuracy = 5) => {
      window.dispatchEvent(new CustomEvent('gpsupdate', { detail: { lat, lng, accuracy } }))
    }
  }
  window.__deviceSensors = {
    getDeviceSensorsManager
  }
}

